'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactLadda = require('react-ladda');

var _reactLadda2 = _interopRequireDefault(_reactLadda);

var _reactRouter = require('react-router');

var _reactDraggableList = require('react-draggable-list');

var _reactDraggableList2 = _interopRequireDefault(_reactDraggableList);

var _document = require('redux/modules/document');

var _schoollevels = require('redux/modules/schoollevels');

var _chapter = require('redux/modules/chapter');

var _components = require('../../components');

var _Parser = require('../../helpers/Parser');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uniqueID = function uniqueID() {
  return Math.floor(Math.random() * Date.now()).toString();
};

var MCQ = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(options) {
    var dispatch = options.store.dispatch,
        _options$params = options.params,
        documentId = _options$params.documentId,
        chapterId = _options$params.chapterId;


    return _promise2.default.all([dispatch((0, _document.load)(documentId)), dispatch((0, _chapter.load)(chapterId)), dispatch((0, _schoollevels.load)())]);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    schoolLevels: state.schoolLevels.data,
    chapter: state.chapter.data,
    document: state.document.data,
    saving: state.document.saving,
    uploadingImage: state.document.uploadingImage,
    uploadedImage: state.document.image,
    config: state.config
  };
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MCQ, _Component);

  function MCQ(props) {
    (0, _classCallCheck3.default)(this, MCQ);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MCQ.__proto__ || (0, _getPrototypeOf2.default)(MCQ)).call(this, props));

    _this.getValue = function () {
      var _this$state = _this.state,
          document = _this$state.document,
          selectedQuestionIndex = _this$state.selectedQuestionIndex,
          selectedQuestionElementPath = _this$state.selectedQuestionElementPath;

      var selectedQuestion = document.questions[selectedQuestionIndex];
      var value = '';
      if (['content', 'detailedAnswer', 'header'].indexOf(selectedQuestionElementPath) > -1) {
        value = selectedQuestion[selectedQuestionElementPath];
      } else {
        value = selectedQuestion.possibleAnswers[selectedQuestionElementPath].content;
      }

      return value.replace(/<br\s*\/?>/mg, '\n');
    };

    _this.handleSaveDocument = function () {
      var document = _this.state.document;

      var isValid = true;

      document.questions.every(function (question, index) {
        var correctAnswer = question.possibleAnswers.find(function (answer) {
          return answer._id === question.correctAnswerId;
        });
        if (!correctAnswer) {
          alert('Erreur : aucune bonne réponse sélectionnée pour la question ' + (index + 1));
          isValid = false;
          return false;
        }

        return true;
      });

      if (isValid) {
        console.log({ document: document });
        _this.props.dispatch((0, _document.save)(document));
      }
    };

    _this.handleOpenImageUploadModal = function () {
      _this.uploadImageInput.click();
    };

    _this.handleCloseImageUploadModal = function () {
      _this.setState({
        imageUploadModalVisible: false,
        uploadedImage: undefined
      });
    };

    _this.handleImageUploadChange = function (event) {
      var data = new FormData();
      data.append('file', event.target.files[0]);
      _this.setState({
        imageUploadModalVisible: true
      });
      _this.props.dispatch((0, _document.uploadImage)({ documentId: _this.state.document._id, data: data }));
    };

    _this.handleOnQuestionClick = function (index) {
      console.log('handleOnQuestionClick', index);
      _this.setState({
        selectedQuestionIndex: index,
        selectedQuestionElementPath: 'content'
      });
    };

    _this.handleCreateQuestion = function () {
      var document = _this.state.document;

      document.questions.push({
        content: 'Question...',
        detailedAnswer: 'Ici la correction...',
        possibleAnswers: [{
          content: 'Réponse 1',
          _id: uniqueID()
        }, {
          content: 'Réponse 2',
          _id: uniqueID()
        }],
        correctAnswerId: '1'
      });

      _this.setState({
        selectedQuestionIndex: document.questions.length - 1,
        selectedQuestionElementPath: 'content',
        document: document
      });
    };

    _this.handleDeleteQuestion = function () {
      if (window.confirm('Etes-vous sûr de vouloir supprimer cette question ?')) {
        var selectedQuestionIndex = _this.state.selectedQuestionIndex;
        var document = _this.state.document;

        // 1. Delete active question

        document.questions.splice(selectedQuestionIndex, 1);

        // 2. Update selected index
        selectedQuestionIndex -= 1;
        if (selectedQuestionIndex < 0) selectedQuestionIndex = 0;

        _this.setState({
          selectedQuestionIndex: selectedQuestionIndex,
          selectedQuestionElementPath: 'content',
          document: document
        });
      }
    };

    _this.handleTextareaChange = function (event) {
      var _this$state2 = _this.state,
          document = _this$state2.document,
          selectedQuestionIndex = _this$state2.selectedQuestionIndex,
          selectedQuestionElementPath = _this$state2.selectedQuestionElementPath;

      var value = event.target.value.replace(/\r?\n/g, '<br />');

      if (['content', 'detailedAnswer', 'header'].indexOf(selectedQuestionElementPath) > -1) {
        document.questions[selectedQuestionIndex][selectedQuestionElementPath] = value;
      } else {
        document.questions[selectedQuestionIndex].possibleAnswers[selectedQuestionElementPath].content = value;
      }

      _this.setState({
        document: document
      });
    };

    _this.handleDeleteQuestionAnswer = function (index) {
      if (window.confirm('Etes-vous sûr de vouloir supprimer cette réponse ?')) {
        var _this$state3 = _this.state,
            document = _this$state3.document,
            selectedQuestionIndex = _this$state3.selectedQuestionIndex;


        document.questions[selectedQuestionIndex].possibleAnswers.splice(index, 1);

        _this.setState({
          selectedQuestionElementPath: 'content',
          document: document
        });
      }
    };

    _this.handleAddQuestionAnswer = function () {
      var _this$state4 = _this.state,
          document = _this$state4.document,
          selectedQuestionIndex = _this$state4.selectedQuestionIndex;


      document.questions[selectedQuestionIndex].possibleAnswers.push({
        _id: uniqueID(),
        content: 'Nouvelle réponse...'
      });

      _this.setState({
        document: document
      });
    };

    _this.handleSetCorrectAnswer = function (answerIndex) {
      var _this$state5 = _this.state,
          document = _this$state5.document,
          selectedQuestionIndex = _this$state5.selectedQuestionIndex;

      document.questions[selectedQuestionIndex].correctAnswerId = document.questions[selectedQuestionIndex].possibleAnswers[answerIndex]._id;

      _this.setState({
        document: document
      });
    };

    _this.state = {
      document: props.document,
      saving: props.saving,
      uploadingImage: false,
      uploadedImage: undefined,
      imageUploadModalVisible: false,
      selectedQuestionIndex: 0,
      selectedQuestionElementPath: 'content'
    };
    return _this;
  }

  (0, _createClass3.default)(MCQ, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (typeof nextProps.document !== 'undefined') {
        var document = nextProps.document;

        this.setState({
          document: document,
          saving: nextProps.saving
        });
      }

      if (typeof nextProps.uploadingImage !== 'undefined') {
        this.setState({
          uploadingImage: nextProps.uploadingImage
        });
      }

      if (typeof nextProps.uploadedImage !== 'undefined') {
        navigator.clipboard.writeText('[image:' + nextProps.uploadedImage.filename + ']');
        this.setState({
          uploadedImage: nextProps.uploadedImage
        });
      }
    }
  }, {
    key: 'onListChange',
    value: function onListChange(newList, movedItem, oldIndex, newIndex) {
      var document = this.state.document;

      var exercise = document.exercises[oldIndex];

      document.exercises.splice(oldIndex, 1);
      document.exercises.splice(newIndex, 0, exercise);

      for (var pos = 0; pos < newList.length; pos++) {
        newList[pos].index = pos;
      }

      this.setState({
        document: document,
        references: newList,
        selectedExerciseIndex: newIndex
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./MCQ.scss');
      var _state = this.state,
          document = _state.document,
          saving = _state.saving,
          uploadingImage = _state.uploadingImage,
          imageUploadModalVisible = _state.imageUploadModalVisible,
          uploadedImage = _state.uploadedImage,
          selectedQuestionIndex = _state.selectedQuestionIndex,
          selectedQuestionElementPath = _state.selectedQuestionElementPath;
      var _props = this.props,
          schoolLevels = _props.schoolLevels,
          chapter = _props.chapter,
          routeParams = _props.routeParams,
          config = _props.config;

      var schoolLevel = schoolLevels.find(function (level) {
        return level._id === routeParams.schoolLevelId;
      });

      var innerHTML = function innerHTML(html) {
        return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: (0, _Parser.textToHtml)(document._id, html, config) } });
      };

      var references = document.questions.map(function (question, index) {
        return {
          index: index,
          onClick: _this2.handleOnQuestionClick
        };
      });

      return _react2.default.createElement(
        'div',
        { className: styles.document },
        _react2.default.createElement('input', { type: 'file', className: styles.imageUploadInput, ref: function ref(input) {
            return _this2.uploadImageInput = input;
          }, onChange: this.handleImageUploadChange }),
        imageUploadModalVisible && _react2.default.createElement(
          _components.Modal,
          { saving: uploadingImage, className: styles.imageUploadModal, onClose: this.handleCloseImageUploadModal },
          uploadedImage && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              null,
              'Code de l\'image \xE0 copier'
            ),
            _react2.default.createElement('textarea', { disabled: true, value: '[image:' + uploadedImage.filename + ']' })
          ),
          uploadingImage && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              null,
              'Import de l\'image en cours...'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.newDocumentToolbar },
          _react2.default.createElement(
            'span',
            { className: styles.breadcrumb },
            _react2.default.createElement(
              _reactRouter.Link,
              { activeClassName: styles.activeItem, className: styles.breadcrumbLink, to: '/schoollevels/' + schoolLevel._id },
              schoolLevel.name
            ),
            '\xA0\xA0>\xA0\xA0',
            _react2.default.createElement(
              _reactRouter.Link,
              { activeClassName: styles.activeItem, className: styles.breadcrumbLink, to: '/schoollevels/' + schoolLevel._id + '/chapters/' + chapter._id },
              chapter.title
            ),
            '\xA0\xA0>\xA0\xA0',
            document.title
          ),
          _react2.default.createElement(
            'button',
            { className: styles.documentSaveButton, onClick: this.handleOpenImageUploadModal },
            'Importer une image'
          ),
          _react2.default.createElement(
            _reactLadda2.default,
            { className: styles.documentSaveButton,
              'data-style': 'slide-down',
              loading: saving, onClick: this.handleSaveDocument },
            _react2.default.createElement(
              'span',
              null,
              'Enregistrer'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.exercisesList },
          _react2.default.createElement(_reactDraggableList2.default, {
            commonProps: { selectedQuestionIndex: selectedQuestionIndex },
            itemKey: 'id',
            template: _components.MCQQuestionsListItem,
            list: references,
            onMoveEnd: function onMoveEnd(newList, movedItem, oldIndex, newIndex) {
              return _this2.onListChange(newList, movedItem, oldIndex, newIndex);
            },
            container: function container() {
              return document.body;
            }
          }),
          _react2.default.createElement(
            'div',
            { onClick: this.handleCreateQuestion,
              className: styles.exercisesListAddItem },
            _react2.default.createElement(
              'div',
              { className: styles.exercisesListItemTitle },
              '+'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.content },
          _react2.default.createElement(
            'button',
            { className: styles.deleteQuestionButton, onClick: this.handleDeleteQuestion },
            'Supprimer la question'
          ),
          document.questions[selectedQuestionIndex].header && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('span', { style: { display: 'flex', margin: '16px 0', border: '1px solid #e5e5e5', boxSizing: 'border-box' } }),
            _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return _this2.setState({ selectedQuestionElementPath: 'header' });
                }, className: styles.questionContent + ' ' + (selectedQuestionElementPath === 'header' ? 'active' : '') },
              innerHTML(document.questions[selectedQuestionIndex].header)
            )
          ),
          _react2.default.createElement('span', { style: { display: 'flex', margin: '16px 0', border: '1px solid #e5e5e5', boxSizing: 'border-box' } }),
          _react2.default.createElement(
            'div',
            { onClick: function onClick() {
                return _this2.setState({ selectedQuestionElementPath: 'content' });
              }, className: styles.questionContent + ' ' + (selectedQuestionElementPath === 'content' ? 'active' : '') },
            innerHTML(document.questions[selectedQuestionIndex].content)
          ),
          _react2.default.createElement('span', { style: { display: 'flex', margin: '16px 0', border: '1px solid #e5e5e5', boxSizing: 'border-box' } }),
          _react2.default.createElement(
            'ul',
            { style: { padding: 0, listStyle: 'none' } },
            document.questions[selectedQuestionIndex].possibleAnswers.map(function (answer, answerIndex) {
              return _react2.default.createElement(
                'li',
                { style: { border: '1px solid #000', padding: '10px 20px', listStyle: 'none', marginBottom: '10px', alignItems: 'center', display: 'flex' } },
                _react2.default.createElement('input', {
                  type: 'checkbox',
                  checked: document.questions[selectedQuestionIndex].correctAnswerId === answer._id,
                  style: { marginRight: '8px' },
                  onClick: function onClick() {
                    return _this2.handleSetCorrectAnswer(answerIndex);
                  }
                }),
                _react2.default.createElement(
                  'div',
                  {
                    onClick: function onClick() {
                      return _this2.setState({ selectedQuestionElementPath: answerIndex });
                    },
                    className: styles.answerContent + ' ' + (selectedQuestionElementPath === answerIndex ? 'active' : '')
                  },
                  innerHTML(answer.content)
                ),
                document.questions[selectedQuestionIndex].possibleAnswers.length > 2 && _react2.default.createElement(
                  'div',
                  { onClick: function onClick() {
                      return _this2.handleDeleteQuestionAnswer(answerIndex);
                    }, style: { cursor: 'pointer' } },
                  '\u274C'
                )
              );
            }),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'button',
                { className: styles.addAnswerButton, onClick: this.handleAddQuestionAnswer },
                'Ajouter une r\xE9ponse'
              )
            )
          ),
          _react2.default.createElement('span', { style: { display: 'flex', margin: '16px 0', border: '1px solid #e5e5e5', boxSizing: 'border-box' } }),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              { className: styles.detailedAnswerTitle },
              'Correction'
            ),
            _react2.default.createElement(
              'div',
              {
                onClick: function onClick() {
                  return _this2.setState({ selectedQuestionElementPath: 'detailedAnswer' });
                },
                className: styles.detailedAnswerContent + ' ' + (selectedQuestionElementPath === 'detailedAnswer' ? 'active' : '')
              },
              innerHTML(document.questions[selectedQuestionIndex].detailedAnswer)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.contentTextArea },
            _react2.default.createElement('textarea', {
              value: this.getValue(),
              onChange: this.handleTextareaChange,
              placeholder: 'Vide'
            })
          )
        )
      );
    }
  }]);
  return MCQ;
}(_react.Component), _class2.propTypes = {
  schoolLevels: _react.PropTypes.array.isRequired,
  chapter: _react.PropTypes.object.isRequired,
  document: _react.PropTypes.object.isRequired,
  saving: _react.PropTypes.bool.isRequired,
  dispatch: _react.PropTypes.func.isRequired,
  routeParams: _react.PropTypes.object.isRequired,
  config: _react.PropTypes.object.isRequired
}, _temp)) || _class) || _class);
exports.default = MCQ;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MCQ/MCQ.js
// module id = 1174
// module chunks = 0